// client/src/utilities/messaging/messageAnnouncementNotificationManager.js

const MessageAnnouncementNotificationManager = async ({ 
  currentUnreadMessages, 
  currentAnnouncementCount,
  userId 
}) => {
  const result = {
    newMessagesCount: 0,
    newAnnouncementsCount: 0,
  };

  try {
    // Storage keys specific to user
    const messageKey = `unreadMessagesCount_${userId}`;
    const announcementKey = `announcementCount_${userId}`;

    // Get previous counts
    const previousMessageCount = parseInt(localStorage.getItem(messageKey), 10) || 0;
    const previousAnnouncementCount = parseInt(localStorage.getItem(announcementKey), 10) || 0;
    
    // Calculate new counts
    if (currentUnreadMessages > 0 && previousMessageCount >= 0) {
      result.newMessagesCount = Math.max(currentUnreadMessages - previousMessageCount, 0);
    }

    if (currentAnnouncementCount > 0 && previousAnnouncementCount >= 0) {
      result.newAnnouncementsCount = Math.max(currentAnnouncementCount - previousAnnouncementCount, 0);
    }

    console.log("💬 Message/Announcement Notification Manager result:", result);
  } catch (err) {
    console.error('MessageAnnouncementNotificationManager error:', err.message || err);
  }

  return result;
};

// Function to update localStorage after viewing
export const clearMessageNotifications = (userId) => {
  const messageKey = `unreadMessagesCount_${userId}`;
  const currentCount = parseInt(localStorage.getItem(messageKey), 10) || 0;
  // Mark as viewed by updating the count
  localStorage.setItem(messageKey, currentCount.toString());
};

export const clearAnnouncementNotifications = (userId) => {
  const announcementKey = `announcementCount_${userId}`;
  const currentCount = parseInt(localStorage.getItem(announcementKey), 10) || 0;
  localStorage.setItem(announcementKey, currentCount.toString());
};

export const updateMessageCount = (userId, count) => {
  const messageKey = `unreadMessagesCount_${userId}`;
  localStorage.setItem(messageKey, count.toString());
};

export const updateAnnouncementCount = (userId, count) => {
  const announcementKey = `announcementCount_${userId}`;
  localStorage.setItem(announcementKey, count.toString());
};

export default MessageAnnouncementNotificationManager;